import { useCallback, useRef, useState } from "react";

type AsyncFn<T> = () => Promise<T>;

export interface SubmitLock {
  isSubmitting: boolean;
  runExclusive: <T>(fn: AsyncFn<T>) => Promise<T | undefined>;
}

export const useSubmitLock = (): SubmitLock => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inFlightRef = useRef(false);

  const runExclusive = useCallback(async <T,>(fn: AsyncFn<T>): Promise<T | undefined> => {
    if (inFlightRef.current) {
      return undefined;
    }

    inFlightRef.current = true;
    setIsSubmitting(true);

    try {
      return await fn();
      
    } finally {
      inFlightRef.current = false;
      setIsSubmitting(false);
    }
  }, []);

  return { isSubmitting, runExclusive };
};

